var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vg-content"},[_c('h3',[_vm._v("暂无权限登录，原因：账号["+_vm._s(_vm.errorMessage)+"]在电子出入证H5管理端未配置功能权限！")]),_c('br'),_c('h5',{staticClass:"text"},[_vm._v("点击"),_c('vg-button',{staticClass:"button",attrs:{"type":"primary"},on:{"click":_vm.signOut}},[_vm._v("这里")]),_vm._v("重新登录！")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }